import layout from '../layout'
export default function makeSCRoutes({
  contentType,
  components: { SCListingContainer }
}) {

  return [
    {
      path: '/',
      component: layout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: `/${contentType.name}/list`,
          component: SCListingContainer,
          props: {
            contentType
          }
        }
      ]
    }
  ];
}
